import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=6c180a17&scoped=true&"
import script from "./Start.vue?vue&type=script&lang=js&"
export * from "./Start.vue?vue&type=script&lang=js&"
import style0 from "./Start.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Start.vue?vue&type=style&index=1&id=6c180a17&scoped=true&lang=css&"
import style2 from "./Start.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c180a17",
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QPage,QCardSection,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QPage,QCardSection,QBtn})
